import teddy from './res/teddy.png';

const NoPage = () => {
  return (
    <div className="row center-main center-cross" style={{ gap: '0px', height: '100%', paddingBlock: '128px' }}>
    <img src={teddy} style={{ height: "256px" }} />
      <div className="column">
        <h1 style={{ fontSize: '72px' }}>Oops...</h1>
        <h2>Sellist lehte pole olemas</h2>
      </div>
    </div>
  )
};

export default NoPage;